import { useEffect, useState } from 'react';
import EditableInfoCard from './EditableInfoCard';
import GenderDistributionChart from './GenderDistributionChart';
import AgeDistributionChart from './AgeDistributionChart';
import EditableHighlightCard from './EditableHighlightCard';
import { useGlobalStates } from '../../utlis/ClubsContext';
import { callApi } from '../../services/ApiServices';
import { formatCurrency, formatWithPercent } from '../../utlis/function';

const AUDIENCE_HIGHLIGHT_CARDS = [
  { label: "Time Not Impression", numberKey: "timeNotImpression", titleKey: "timeNotImpressionTitle", descriptionKey: "timeNotImpressionDescription" },
  { label: "Every Single Week", numberKey: "everySingleweek", titleKey: "everySingleweekTitle", descriptionKey: "everySingleweekDescription" },
  { label: "Everyone Is Local", numberKey: "everyOneLocal", titleKey: "everyOneLocalTitle", descriptionKey: "everyOneLocalDescription" },
];

const PERFORMANCE_STAT_CARDS = [
  { label: "Ad Recall", numberKey: "adRecall", descriptionKey: "adRecallDescription" },
  { label: "Digital Out-of-Home Brand Lift", numberKey: "digitalOutOfHome", descriptionKey: "digitalOutOfHomeDescription" },
  { label: "Purchase Intent vs Static Out-of-Home", numberKey: "staticOutOfHome", descriptionKey: "staticOutOfHomeDescription" },
  { label: "Viewable / Ad-Blocker Proof", numberKey: "addBlocker", descriptionKey: "addBlockerDescription" },
];

const AudiencePerformanceTab = () => {
  const{ selectedClub, handleSelectedClubDetail, setSelectedClub} = useGlobalStates()
  console.log("selectedClub", selectedClub)
const [savingField, setSavingField] = useState(null);


 const stats = {
  totalMembers: selectedClub?.clubTotalMembers,
  monthlyVisits: selectedClub?.clubMonthlyVisits,
  avgHouseholdIncome: formatCurrency(selectedClub?.avgHouseHoldIncome),
  avgDailyVisit: selectedClub?.avgDailyVisits,
  screensAcrossClub: selectedClub?.totalScreensCount,
  avgDwellTime: selectedClub?.avgDwellTime,
  dailyImpressions: selectedClub?.dailyImpressions,
  monthlyImpressions: selectedClub?.monthlyImpressions,
  avgCPM: formatCurrency(selectedClub?.avgCpm),
  engagementRate: formatWithPercent(selectedClub?.engagementRate ),
  collegePercentage: formatWithPercent(selectedClub?.collegePercentage)
};

const sanitizeValue = (key, value) => {
  if (value === null || value === undefined) return null;

  const stringValue = String(value).trim();

  // ✅ Percentage fields → remove %
  if (key === "engagementRate") {
    const cleaned = stringValue.replace(/[^0-9.]/g, "");
    return cleaned === "" ? null : Number(cleaned);
  }

  // ✅ Currency / numeric fields
  const cleaned = stringValue.replace(/[^0-9.]/g, "");
  return cleaned === "" ? null : Number(cleaned);
};


  
const handleEdit = async (key, value) => {
  const fieldMap = {
    totalMembers: "clubTotalMembers",
    monthlyVisits: "clubMonthlyVisits",
    avgHouseholdIncome: "avgHouseHoldIncome",
    avgDailyVisit: "avgDailyVisits",
    screensAcrossClub: "totalScreensCount",
    avgDwellTime: "avgDwellTime",
    dailyImpressions: "dailyImpressions",
    monthlyImpressions: "monthlyImpressions",
    avgCPM: "avgCpm",
    engagementRate: "engagementRate",
    collegePercentage: "collegePercentage"
  };

  const apiKey = fieldMap[key];
  console.log("apikey", apiKey)

const cleanedValue = sanitizeValue(key, value);

  try {
    // ✅ 2. Call API
    setSavingField(apiKey);
   const res =  await callApi({
      method: "put",
      url: `/club/update/${selectedClub?.id}`,
      data: {
        fields: {
          [apiKey]: cleanedValue,
        },
      },
    });
    if(res.status===200){
       await handleSelectedClubDetail(selectedClub)
    }
  } catch (error) {
    console.error("Update failed", error);
  }finally{
    setSavingField(null)
  }
};


  // const handleEdit = (key, newValue) => {
  //   setStats({ ...stats, [key]: newValue });
  // };

  return (
    <div className="space-y-4">
      {/* First Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <EditableInfoCard
          title="Total Members"
          value={stats.totalMembers }
          onSave={(newValue) => handleEdit('totalMembers', newValue)}
          validationType="numeric"
          fieldName="Total Members"
          isLoading={savingField === "clubTotalMembers"}
        />
        <EditableInfoCard
          title="Average Monthly Visits"
          value={stats.monthlyVisits}
          onSave={(newValue) => handleEdit('monthlyVisits', newValue)}
          validationType="numeric"
          fieldName="Average Monthly Visits"
          isLoading={savingField==="clubMonthlyVisits"}
        />
        <EditableInfoCard
          title="Avg. Household Income"
          value={stats.avgHouseholdIncome}
          onSave={(newValue) => handleEdit('avgHouseholdIncome', newValue)}
          validationType="numeric"
          fieldName="Average Household Income"
          isLoading={savingField==="avgHouseHoldIncome"}
        />
      </div>

      {/* Second Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <EditableInfoCard
          title="Average Daily Visit"
          value={stats.avgDailyVisit}
          onSave={(newValue) => handleEdit('avgDailyVisit', newValue)}
          validationType="numeric"
          fieldName="Average Daily Visit"
          isLoading={savingField === "avgDailyVisits"}
        />  
        <EditableInfoCard
          title="Displays"
          value={stats.screensAcrossClub}
          onSave={(newValue) => handleEdit('screensAcrossClub', newValue)}
          validationType="numeric"
          fieldName="Displays Across the Club"
          isLoading={savingField === "totalScreensCount"}
        />
        <EditableInfoCard
          title="Average Visit Length"
          value={stats.avgDwellTime}
          onSave={(newValue) => handleEdit('avgDwellTime', newValue)}
          validationType="currency"
          fieldName="Average Visit Length"
          isLoading={savingField === "avgDwellTime"}
        />
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <GenderDistributionChart />
        <AgeDistributionChart />
      </div>

      {/* ---Performances Bar---- */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <EditableInfoCard
          title="Daily Visits"
          value={stats.dailyImpressions}
          onSave={(newValue) => handleEdit('dailyImpressions', newValue)}
          validationType="numeric"
          fieldName="Daily Visits"
          isLoading={savingField === "dailyImpressions"}
        />
        <EditableInfoCard
          title="Monthly Visits"
          value={stats.monthlyImpressions }
          onSave={(newValue) => handleEdit('monthlyImpressions', newValue)}
          validationType="numeric"
          fieldName="Monthly Visits"
          isLoading={savingField==="monthlyImpressions"}
        />
        <EditableInfoCard
          title="Average CPM"
          value={stats.avgCPM}
          onSave={(newValue) => handleEdit('avgCPM', newValue)}
          validationType="currency"
          fieldName="Average CPM"
          isLoading={savingField==="avgCpm"}
        />
        <EditableInfoCard
          title="Engagement Rate"
          value={stats.engagementRate}
          onSave={(newValue) => handleEdit('engagementRate', newValue)}
          validationType="percentage"
          fieldName="Engagement Rate"
          isLoading={savingField==="engagementRate"}
        />

        <EditableInfoCard
          title="College Educated(%)"
          value={stats.collegePercentage}
          onSave={(newValue) => handleEdit('collegePercentage', newValue)}
          validationType="percentage"
          fieldName="College Educated"
          isLoading={savingField==="collegePercentage"}
        />
      </div>

      {/* Audience Highlights (number + title + description) */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {AUDIENCE_HIGHLIGHT_CARDS.map((card) => (
          <EditableHighlightCard key={card.numberKey} card={card} />
        ))}
      </div>

      {/* Performance Stats (number + description) */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {PERFORMANCE_STAT_CARDS.map((card) => (
          <EditableHighlightCard key={card.numberKey} card={card} />
        ))}
      </div>
    </div>
  );
};

export default AudiencePerformanceTab;
